Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropdownNativeSelect665082473",
  {"wrapper":"DropdownNativeSelect665082473--wrapper","root":"DropdownNativeSelect665082473--root","arrowIcon":"DropdownNativeSelect665082473--arrowIcon","errorIcon":"DropdownNativeSelect665082473--errorIcon","errorIconWrapper":"DropdownNativeSelect665082473--errorIconWrapper","optionIcon":"DropdownNativeSelect665082473--optionIcon","BorderHoverColor":"color-5","borderHoverColor":"\"color(color-5)\""},
  "",
  8,
  "DropdownNativeSelect665082473"
);

